export const IconIndeterminate = ({
  className,
  color = "white",
}: {
  className?: string
  color?: string
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <line
      x1="3"
      y1="8"
      x2="13"
      y2="8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
